import { useQuery } from '@tanstack/react-query'

import {
  CompanySuggestionResponse,
  DeclinedJoinRequestResponse,
  JoinRequestResponse,
  MembershipResponse,
} from '@/lib/definitions/api.types'
import { MembershipService } from '@/lib/services/MembershipService'

const membershipService = new MembershipService()

export const useLoadJoinRequests = (enabled: boolean = true) =>
  useQuery<JoinRequestResponse[]>({
    queryKey: ['fetchJoinRequests'],
    queryFn: async () => (await membershipService.getJoinRequests()).data,
    enabled,
    refetchInterval: 30_000,
    meta: {
      error: { message: 'Could not load the join requests' },
    },
  })

export const useLoadDeclinedJoinRequests = (enabled: boolean = true) =>
  useQuery<DeclinedJoinRequestResponse[]>({
    queryKey: ['fetchDeclinedJoinRequests'],
    queryFn: async () =>
      (await membershipService.getDeclinedJoinRequests()).data,
    enabled,
    meta: {
      error: { message: 'Could not load the declined requests' },
    },
  })

export const useLoadMyJoinRequests = (enabled: boolean = true) =>
  useQuery<JoinRequestResponse[]>({
    queryKey: ['fetchMyJoinRequests'],
    queryFn: async () => (await membershipService.getMyJoinRequests()).data,
    enabled,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
    meta: {
      error: { message: 'Could not load your join requests' },
    },
  })

export const useLoadCompanySuggestions = (enabled: boolean = true) =>
  useQuery<CompanySuggestionResponse[]>({
    queryKey: ['fetchCompanySuggestions'],
    queryFn: async () => (await membershipService.getCompanySuggestions()).data,
    enabled,
  })

export const useLoadMyInvitations = (enabled: boolean = true) =>
  useQuery<JoinRequestResponse[]>({
    queryKey: ['fetchMyInvitations'],
    queryFn: async () => (await membershipService.getMyInvitations()).data,
    enabled,
    refetchInterval: 30_000,
    meta: {
      error: { message: 'Could not load your invitations' },
    },
  })

export const useLoadMemberships = (enabled: boolean = true) =>
  useQuery<MembershipResponse[]>({
    queryKey: ['fetchMemberships'],
    queryFn: async () => (await membershipService.getMemberships()).data,
    enabled,
    meta: {
      error: { message: 'Could not load your companies' },
    },
  })
